import imageCompression from 'browser-image-compression';

import { ID_PHOTO_COMPRESSION_OPTIONS, type IdImage, toIdImage } from '@dutchie-pos/requests/checkin/camera-id-scan';

/** Downscales first: a phone frame is megabytes and the server rejects over-limit images. */
export const readIdPhoto = async (file: File): Promise<IdImage | null> => {
  if (!file.type.startsWith('image/')) {
    return null;
  }

  const compressed = await imageCompression(file, ID_PHOTO_COMPRESSION_OPTIONS);

  return toIdImage(await imageCompression.getDataUrlFromFile(compressed));
};
